<template>
  <dl class="prefer" v-if="prefers.length">
    <dt class="prefer-header">
      <div class="prefer-header__left">为你优选</div>
      <div class="prefer-header__right">
        <button class="prefer-button__change" @click="onPageChange">
          <i class="el-icon-refresh"></i>
          <span>换一换</span>
        </button>
      </div>
    </dt>
    <dd class="prefer-list">
      <router-link
        class="prefer-item"
        :to="`/detail/${item.property.topics[0]['englishName']}/${item.id}`"
        v-for="(item, i) in prefers"
        :key="i"
      >
        <YorkbbsImage class="prefer-cover" :src="item.property.coverImage"></YorkbbsImage>
        <div class="prefer-title e-2">
          <span>{{ item.title }}</span>
        </div>
        <div class="prefer-topic">
          <span>{{ item.property.topics[0]['name'] }}</span>
        </div>
      </router-link>
    </dd>
  </dl>
</template>
<script>
import { off } from 'element-ui/src/utils/dom';
export default {
  name: 'Prefer',
  data() {
    return {
      offset: 1,
      size: 3,
      loading: false,
      prefers: [],
      pageTotal: 0,
    };
  },
  created() {
    this.getPrefers();
  },
  methods: {
    /**
     * 缓一缓
     */
    onPageChange() {
      const offset = this.offset + 1;
      this.offset = offset > this.pageTotal ? 1 : offset;

      this.getPrefers();
    },
    /**
     * 获取为你优选列表
     */
    async getPrefers() {
      this.loading = true;
      const { data } = await this.$axios
        .post('/info/v1/get/others/post/list', {
          offset: this.offset,
          size: this.size,
          postId: this.$route.params.id,
        })
        .finally(() => {
          this.loading = false;
        });

      this.prefers = data.items;
      this.pageTotal = data.pageTotal;
    },
  },
};
</script>
<style lang="scss" scoped>
.prefer {
  background: #f8f8f8;
  border-radius: 4px;
  padding: 20px;
  margin-bottom: 50px;
}
.prefer-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.prefer-header__left {
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
}
.prefer-button__change {
  font-size: 14px;
  color: var(--text-color-6);
  margin-bottom: 10px;
  i {
    font-size: 12px;
    margin-right: 5px;
  }
  &:hover {
    color: var(--primary-color);
  }
}
.prefer-list {
  display: flex;
  justify-content: space-between;
}
.prefer-item {
  width: 250px;
}
.prefer-cover {
  width: 100%;
  height: 177px;
  border-radius: 4px;
  border: 1px solid #eee;
}
.prefer-title {
  font-size: 16px;
  line-height: 22px;
  color: var(--text-color-3);
  margin-top: 10px;
  &:hover {
    color: var(--primary-color);
  }
}
.prefer-topic {
  font-size: 14px;
  line-height: 20px;
  margin-top: 2px;
  color: var(--text-color-9);
}
</style>
